import instance from "@/services/api";

export const shellProjectsAPI = {
  async getList(params = {}) {
    return await instance()
      .get("/floor_map/project/read/", { params })
      .then((res) => res?.data);
  },
  async updateShellProject(body, params) {
    return await instance()
      .post("/floor_map/project/upd/", body, { params })
      .then((res) => res?.data);
  },
  async getProjectInfo(project_id) {
    return await instance()
      .get(`/floor_map/project/${project_id}/info/`)
      .then((res) => res?.data);
  },
  async updProjectInfo(body) {
    return await instance()
      .post(`/floor_map/project/info_upd/`, body)
      .then((res) => res?.data);
  },
  async getProjectTypes() {
    return await instance()
      .get("/floor_map/project/type/")
      .then((res) => res?.data);
  },
  async getEmployeeList() {
    return await instance()
      .get("/floor_map/project/employee_list/")
      .then((res) => res?.data);
  },
  async getEntrancesBlockInfo(project_id) {
    return await instance()
      .get(`/floor_map/project/${project_id}/blocks/`)
      .then((res) => res?.data);
  },
  async updEntrancesBlockInfo(body) {
    return await instance()
      .post(`/floor_map/project/blocks_upd/`, body)
      .then((res) => res?.data);
  },
  async getPerformersByProjectId(project_id) {
    return await instance()
      .get(`/floor_map/project/read_assign/project_id/${project_id}/`)
      .then((res) => res?.data);
  },
  async getAssignTypes() {
    return await instance()
      .get(`/floor_map/project/assign_type/`)
      .then((res) => res?.data);
  },
  async getContractors() {
    return await instance()
      .get(`/common/contractors/read/`)
      .then((res) => res?.data);
  },
  async getEmployeesListByContractorId(contractor_id) {
    return await instance()
      .get(`/common/employees/contractor_id/${contractor_id}/`)
      .then((res) => res?.data);
  },
  async getProjectsById(project_id) {
    return await instance()
      .get(`/floor_map/project/${project_id}/projects_resident/`)
      .then((res) => res?.data);
  },
  async updateShellProjectPerfomancer(body) {
    return await instance()
      .post("/floor_map/project/assign_upd/", body)
      .then((res) => res?.data);
  },
  async copyPasteEntranceProperties(body, params) {
    return await instance()
      .post("/floor_map/project/dublicate_entrance/", body, { params })
      .then((res) => res?.data);
  },
  async transferProject(body, params) {
    return await instance()
      .post("/floor_map/project/transfer/", body, { params })
      .then((res) => res?.data);
  },
  async deleteShellProjectPerfomancer(body) {
    return await instance()
      .post(`/floor_map/project/assign_del/`, body)
      .then((res) => res?.data);
  },
  async changeProjectStatus(project_id, params) {
    return await instance()
      .post(`/floor_map/project/${project_id}/change_status/`, {}, { params })
      .then((res) => res?.data);
  },
  async changeProjectEntrances(body, params) {
    return await instance()
      .post(`/floor_map/project/entrance/`, body, { params })
      .then((res) => res?.data);
  },
  async fillEntranceFlats(project_id, params) {
    return await instance()
      .post(`/floor_map/project/${project_id}/fill_flat/`, {}, { params })
      .then((res) => res?.data);
  },
  async generateDoc(body) {
    return await instance()
      .post(`floor_map/project/agreement_add/`, body)
      .then((res) => res?.data);
  },
  async downloadDoc(body) {
    return await instance()
      .post(`floor_map/project/get_signed_agreement/`, body)
      .then((res) => res?.data);
  },
  async deleteDoc(project_agreement_id) {
    return await instance()
      .delete(`/floor_map/project/agreement_del/${project_agreement_id}/`)
      .then((res) => res?.data);
  },
  async putSBSProject(body) {
    return await instance()
      .post(`/handbook/contractor/sbs_project/get/`, body)
      .then((res) => res?.data);
  },
  async getProjectEntrances(project_id) {
    return await instance()
      .get(`/floor_map/project/read_entrance/${project_id}/`)
      .then((res) => res?.data);
  },
  async getProjectMaterials(project_id) {
    return await instance()
      .get(`/floor_map/project/read_material/${project_id}/`)
      .then((res) => res?.data);
  },
  async recalcProjectSmeta(project_id) {
    return await instance()
      .post(`/floor_map/project/recalc_smeta/${project_id}/`)
      .then((res) => res?.data);
  },
  async replaceWorksetMaterials(body) {
    return await instance()
      .post(`/floor_map/project/material_upd/`, body)
      .then((res) => res?.data);
  },
};
